import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import withAuth from "../../components/withAuth";

// STATE AND STORE
// LIBS
import API from "../../api";
import {
  fioLitleTruncateFromObject,
  sumFormat,
  suffixMoney
} from "../../lib/helpers/strings";
import { getDateFormat } from "../../lib/helpers/dates";
import {
  getStatusBlankString,
  getTitleAddOrGive,
  getTypeBlank
} from "../../lib/helpers/blanks";

// UI
import { Box, Header, HeaderPage, P, Button, Row, Col } from "../../ui";
import IconArrowUpLongBold from "../../ui/src/ui/components/icons/arrowUpLongBold";
import IconArrowDownLongBold from "../../ui/src/ui/components/icons/arrowDownLognBold";

class BlankOnePage extends Component {
  state = {
    titleHeader: "Кассовый ордер",
    blank: { user_id: {}, depositor_id: {}, filial_id: {} }
  };

  async componentDidMount() {
    const { id } = this.props.match.params;

    const blank = await API.blanks.getOne(id);

    let titleHeader = `${blank.blank_number} - ${this.state.titleHeader}`;

    this.setState({ blank, titleHeader });
  }

  render() {
    const { id } = this.props.match.params;
    const { blank } = this.state;

    if (blank && blank.blank_number) {
      const userOrDepositorGiveAdd = getTypeBlank(blank);

      return (
        <div className="short">
          <Helmet>
            <title>{this.state.titleHeader}</title>
          </Helmet>

          <HeaderPage
            title={this.state.titleHeader + " №" + blank.blank_number}
            back={this.props.history.goBack}
          />

          <Box>
            <Row withMain={true}>
              <Col padding="no" main={true}>
                <Header size={2} margin="no-top">
                  Текущее состояние
                </Header>
              </Col>
              <Col padding="no" normal={true}>
                <Button size="s" type="as" as={Link} to={`/blanks/${id}/edit`}>
                  Изменить состояние
                </Button>
              </Col>
            </Row>

            <Row>
              <Col padding="no-top-left">
                <Header size={5} margin="no-top">
                  Главное
                </Header>

                <Header size={6} margin="no-bottom">
                  Номер к/о:
                </Header>
                <P slim={true}>{blank.blank_number}</P>

                <Header size={6} margin="no-bottom">
                  Филиал:
                </Header>
                <P slim>
                  <Link to={`/filials/${blank.filial_id._id}`}>
                    {blank.filial_id.name}
                  </Link>
                </P>
              </Col>

              <Col padding="no-top-left">
                <Header size={5} margin="no-top">
                  Операция
                </Header>

                <Header size={6} margin="no-bottom">
                  Тип:
                </Header>
                <P slim={true}>
                  {blank.blank_type === "type_add" ? (
                    <IconArrowDownLongBold className="icon-xl icon-margin-right icon-bottom icon-success-active" />
                  ) : (
                    <IconArrowUpLongBold className="icon-xl icon-margin-right icon-bottom icon-error" />
                  )}
                  {getStatusBlankString(blank.blank_type)}
                </P>

                <Header size={6} margin="no-bottom">
                  Основание:
                </Header>
                <P slim={true}>{blank.reason}</P>

                {!!blank.bilet_id ? (
                  <div>
                    <Header size={6} margin="no-bottom">
                      Залоговый билет:
                    </Header>
                    <P slim={true}>
                      <Link to={`/bilets/${blank.bilet_id._id}`}>
                        {blank.bilet_id.bilet_number}
                      </Link>
                    </P>
                  </div>
                ) : null}
              </Col>

              <Col padding="no-top">
                <Header size={5} margin="no-top">
                  Деньги
                </Header>

                <Header size={6} margin="no-bottom">
                  Сумма:
                </Header>
                <P slim={true}>{sumFormat(blank.sum, suffixMoney)}</P>
              </Col>

              <Col padding="no-top">
                <Header size={5} margin="no-top">
                  Люди
                </Header>

                <Header size={6} margin="no-bottom">
                  {getTitleAddOrGive(blank)}:
                </Header>
                <P slim={true}>
                  {userOrDepositorGiveAdd.isHaveId ? (
                    <Link
                      to={`/${userOrDepositorGiveAdd.type}s/${userOrDepositorGiveAdd._id}`}
                    >
                      {userOrDepositorGiveAdd.fio}
                    </Link>
                  ) : (
                    userOrDepositorGiveAdd.fio
                  )}
                </P>

                <Header size={6} margin="no-bottom">
                  Ответсвенный:
                </Header>
                <P slim={true}>
                  <Link to={`/users/${blank.user_id._id}`}>
                    {fioLitleTruncateFromObject(blank.user_id)}
                  </Link>
                </P>
              </Col>

              <Col padding="no-top-right">
                <Header size={5} margin="no-top">
                  Изменения
                </Header>

                <Header size={6} margin="no-bottom">
                  Дата создания к/о:
                </Header>
                <P slim={true}>{getDateFormat(blank.created_at)}</P>

                <Header size={6} margin="no-bottom">
                  Дата обновления к/о:
                </Header>
                <P slim={true}>{getDateFormat(blank.updated_at)}</P>
              </Col>
            </Row>
          </Box>
        </div>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = state => ({});

export default connect(mapStateToProps)(withAuth(BlankOnePage));
